import { z } from 'zod';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';
import { S3StorageError } from 'libs/end-to-end/src/types/errors/s3-storage-error';
import { BufferToStringError } from 'libs/end-to-end/src/types/errors/buffer-to-string-error';
import { JsonParseError } from 'libs/end-to-end/src/types/errors/json-parse-error';

export const GetJsonDocumentError = z.union([
  S3StorageError,
  BufferToStringError,
  JsonParseError,
  UnknownError,
]);

export type GetJsonDocumentError = z.infer<typeof GetJsonDocumentError>;
